import React, { Component } from "react";

import auth from "../../lib/auth";

class Logout extends Component {
  componentDidMount = async () => {
    await auth.logout();
  };

  render() {
    return <div className="loading-page-overview">
    </div>;
  }
}

export default Logout;
